import React from 'react'
import { FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { useDashboardDomainContext } from '../../../DashboardDomainProvider';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

export const Icon = () => {
    const { iconSelectData } = useDashboardDomainContext();
    const { visualObject, setVisualObject } = useVisualFormContext();

    return (
        <FieldControl
            fieldMetadata={{
                FieldType: SystemTypes.UIFieldType.SearchSelectList,
                FieldName: "VisualIcon",
                DisplayName: "Icon",
                DataJson: iconSelectData
            }}
            groupId={"visual"}
            value={visualObject?.icon}
            onChange={v => {
                setVisualObject(prev => ({
                    ...prev,
                    icon: v,
                }));
            }}
        />
    )
}